module.exports = __webpack_public_path__ + "static/media/volume1.6497c327.svg";